/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { DnsRecord, DnsRecord$inboundSchema } from "./dnsrecord.js";
import { DomainConnect, DomainConnect$inboundSchema } from "./domainconnect.js";

export type V1DomainsCreateDomainResponseData = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  domainId: string;
  /**
   * Every DNS record needed to finish setting up this domain, ready to create at your provider.
   *
   * @remarks
   * The list already accounts for whether the domain is an apex or a subdomain, so no further
   * branching is needed: create each entry as given.
   *
   * One record establishes routing and one proves ownership. Create all of them: whether ownership
   * can be inferred from the routing record depends on how your provider publishes it, and a name
   * another workspace has already verified can only be claimed through the ownership record.
   * Neither is knowable before the records exist.
   */
  dnsRecords: Array<DnsRecord>;
  /**
   * One-click setup at the domain's DNS provider. Omitted entirely when the provider does not support
   *
   * @remarks
   * Domain Connect or discovery failed, so the object's presence is the signal that the shortcut is
   * available and both of its fields are filled.
   */
  domainConnect?: DomainConnect | undefined;
};

/** @internal */
export const V1DomainsCreateDomainResponseData$inboundSchema: z.ZodType<
  V1DomainsCreateDomainResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  domainId: z.string(),
  dnsRecords: z.array(DnsRecord$inboundSchema),
  domainConnect: DomainConnect$inboundSchema.optional(),
});

export function v1DomainsCreateDomainResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1DomainsCreateDomainResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1DomainsCreateDomainResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1DomainsCreateDomainResponseData' from JSON`,
  );
}
